import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import CompanyFeatureFlagsEnum, { CompanyFeatureFlagsTips } from 'ab-enums/companyFeatureFlags.enum';

import { Button } from '@acceligentllc/storybook';

import Checkbox from 'af-components/Controls/Checkbox';
import CustomModal from 'af-components/CustomModal';
import SubmitButton from 'af-components/SubmitButton';

import * as CompanyActions from 'af-actions/companies';

import PreviewItem from '../../Shared/PreviewItem';

type OwnProps = {
	showModal: boolean;
	closeModal: () => void;
	arePortalFunctionalitiesEnabled: boolean;
};

type Props = OwnProps & ConnectedProps<typeof connector>;

const EnableWorkRequestsCompanyEdit: React.FC<Props> = ({ closeModal, showModal, arePortalFunctionalitiesEnabled, editEnablePortalFunctionalities }) => {
	const [enableWorkRequests, setEnableWorkRequests] = React.useState(arePortalFunctionalitiesEnabled);

	const renderLabel = React.useCallback(() => {
		return (
			<PreviewItem
				checked={!!arePortalFunctionalitiesEnabled}
				hint={CompanyFeatureFlagsTips.portalFunctionalities}
				indent={false}
				label={CompanyFeatureFlagsEnum.arePortalFunctionalitiesEnabled}
				showCheckbox={false}
			/>
		);
	}, [arePortalFunctionalitiesEnabled]);

	const handleChange = React.useCallback((event) => {
		setEnableWorkRequests(event.target.checked);
	}, []);

	const handleSubmit = React.useCallback(async () => {
		await editEnablePortalFunctionalities({ arePortalFunctionalitiesEnabled: enableWorkRequests });
		closeModal();
	}, [editEnablePortalFunctionalities, enableWorkRequests, closeModal]);

	return (
		<CustomModal
			closeModal={closeModal}
			modalStyle="info"
			showModal={showModal}
			size="lg"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title="Edit Portal Functionalities"
			/>
			<CustomModal.Body>
				<Checkbox
					handleChange={handleChange}
					isChecked={enableWorkRequests}
					label={renderLabel()}
				/>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={closeModal}
					style="secondary"
				/>
				<SubmitButton
					label="Save"
					onClick={handleSubmit}
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

function mapDispatchToProps() {
	return {
		editEnablePortalFunctionalities: CompanyActions.editEnablePortalFunctionalities,
	};
}

const connector = connect(null, mapDispatchToProps());

export default connector(EnableWorkRequestsCompanyEdit);
